module.exports = __webpack_public_path__ + "static/img/BD.8da88d8b.jpg";